var render = function render(){var _vm=this,_c=_vm._self._c;return _c('calendar',{on:{"destroyLocalStorage":function($event){return _vm.getEventCount()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }